// extracted by mini-css-extract-plugin
export default {"estimatedBudget":"EstimatedCampaignField_estimatedBudget__4H9UP","error":"EstimatedCampaignField_error__KOJJw"};